import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface Office {
  labelKey: string;
  name: string;
  map: SafeResourceUrl;
  address: string[];
  infoEmail: string;
  supportEmail: string;
  infoPhone: string;
  supportPhone: string;
  hours: string;
  reverse: boolean;
}

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.scss'],
})
export class ContactoComponent {
  readonly offices: Office[];

  constructor(sanitizer: DomSanitizer) {
    const safe = (u: string) => sanitizer.bypassSecurityTrustResourceUrl(u);
    this.offices = [
      {
        labelKey: 'contacto.officeMain',
        name: 'Gesvatec Sistemas, S.L',
        map: safe('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10308313.784716278!2d-0.012493995977175746!3d41.39902936288864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd60487b2fbc7935%3A0x87576319fd203a3a!2sGesvatec%20Sistemas%2C%20S.L!5e0!3m2!1ses!2ses!4v1678981976205!5m2!1ses!2ses'),
        address: ['Av. de las Cortes Valencianas, 47', 'Edificio IKON - Torre B Local 3', '46015 VALENCIA - España'],
        infoEmail: 'info@gesvatec.com',
        supportEmail: 'soporte@gesvatec.com',
        infoPhone: '+34 963 391 890',
        supportPhone: '+34 963 939 160',
        hours: '09:00 - 19:00 (GMT+1)',
        reverse: false,
      },
      {
        labelKey: 'contacto.officeUsa',
        name: 'Gesvatec Systems, LLC',
        map: safe('https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d19057808.461653765!2d-112.57057679166164!3d46.09969282894373!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dc03e4213822a5%3A0xfb4afb70cccbbe64!2s737%20Pearl%20St%20%23201%2C%20La%20Jolla%2C%20CA%2092037%2C%20EE.%20UU.!5e0!3m2!1ses!2ses!4v1678982150564!5m2!1ses!2ses'),
        address: ['737 Pearl street, Suite 201, La Jolla, San Diego, California 92037 (USA)'],
        infoEmail: 'info@gesvatec.com',
        supportEmail: 'soporte@gesvatec.com',
        infoPhone: '+1 312 554 9151',
        supportPhone: '+34 963 939 160',
        hours: '09:00 - 19:00 (PST)',
        reverse: true,
      },
    ];
  }
}
